import { Injectable, signal } from '@angular/core';
import { productFruits, ProductFruitsInitOptions, ProductFruitsUserObject } from 'product-fruits';

@Injectable({ providedIn: 'root' })
export class ProductFruitsService {
  private readonly _ready = signal(false);
  private readonly _inAppCenterIsOpened = signal(false);

  public readonly ready = this._ready.asReadonly();
  public readonly inAppCenterIsOpened = this._inAppCenterIsOpened.asReadonly();

  private initialized = false;

  public init(workspaceCode: string, language: string, userObject?: ProductFruitsUserObject, options?: ProductFruitsInitOptions): void {
    if (this.initialized) {
      console.warn('ProductFruitsService has already been initialized.');
      return;
    }

    productFruits.init(workspaceCode, language, userObject, options);

    productFruits.safeExec(() => {
      this._ready.set(true);
      this.attachInAppCenterListeners();
    });

    this.initialized = true;
  }

  public attachHelpCenterButton(button: HTMLButtonElement): void {
    if (!this._ready()) {
      console.warn('ProductFruits is not ready yet. Cannot attach help center button.');
      return;
    }

    productFruits.safeExec(() => {
      window.productFruits.api.inAppCenter.attachToCustomElement(button);
    });
  }

  private attachInAppCenterListeners(): void {
    window.productFruits.api.inAppCenter.listen('opened', () => this._inAppCenterIsOpened.set(true));
    window.productFruits.api.inAppCenter.listen('closed', () => this._inAppCenterIsOpened.set(false));
  }
}
